var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgE5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.04 59.9928C120.04 26.8557 93.1769 -0.00715526 60.0398 -0.00715566C26.9027 -0.00715605 0.039796 26.8557 0.0397956 59.9928C0.0397952 93.1299 26.9027 119.993 60.0398 119.993C93.1769 119.993 120.04 93.1299 120.04 59.9928Z",
    fill: "#5EC665"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9234 45.6016C47.9234 50.0831 44.7345 53.7195 40.8069 53.7195C36.8794 53.7195 33.6904 50.0831 33.6904 45.6016C33.6904 41.1201 36.8794 37.4837 40.8069 37.4837C44.7345 37.4837 47.9234 41.1201 47.9234 45.6016Z",
    fill: "#939598"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3892 45.6016C86.3892 50.0831 83.2003 53.7195 79.2727 53.7195C75.3452 53.7195 72.1562 50.0831 72.1562 45.6016C72.1562 41.1201 75.3452 37.4837 79.2727 37.4837C83.2003 37.4837 86.3892 41.1201 86.3892 45.6016Z",
    fill: "#939598"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8793 31.4326C38.2358 31.4539 34.6989 32.6826 31.8224 34.9198C30.821 35.694 29.3722 35.7792 28.4489 34.9411C27.5327 34.1102 27.7316 32.4056 29.0526 31.3758C32.7103 28.5278 37.2131 26.9653 41.8508 26.9369C43.5341 26.9298 44.7415 28.1371 44.5355 29.3587C44.3367 30.5874 43.1364 31.4184 41.8793 31.4326Z",
    fill: "#939598"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2001 31.4326C81.8436 31.4539 85.3805 32.6826 88.257 34.9198C89.2584 35.694 90.7073 35.7792 91.6305 34.9411C92.5467 34.1102 92.3479 32.4056 91.0269 31.3758C87.3692 28.5278 82.8663 26.9653 78.2286 26.9369C76.5453 26.9298 75.3379 28.1371 75.5439 29.3587C75.7427 30.5874 76.943 31.4184 78.2001 31.4326Z",
    fill: "#939598"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6321 73.2437C37.5468 72.4553 38.4204 71.9085 39.0738 72.363C43.2074 75.14 50.9204 77.8815 60.0327 77.7394C69.1591 77.8886 76.858 75.14 80.9915 72.363C81.0412 72.3204 81.098 72.2991 81.1477 72.2778C81.7798 71.9937 82.5185 72.5122 82.4333 73.2437C82.1918 75.4596 81.7514 77.4411 81.1477 79.1954C76.1122 93.8332 60.0256 93.0448 60.0256 93.0448C60.0256 93.0448 39.8764 94.025 37.625 73.2366L37.6321 73.2437Z",
    fill: "#939598"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE5);
export default __webpack_public_path__ + "static/media/E5.d7effedb65f54c8676727b21cedc19ca.svg";
export { ForwardRef as ReactComponent };